export const CONTROL_CONSOLIDATED_PRODUCTION =
  '/control_consolidated_production/';
export const CONTROL_CONSOLIDATED_PRODUCTION_BY_ID = id =>
  `/control_consolidated_production/${id}/`;
